import React, { useState } from "react";
import PropTypes from "prop-types";
import { scrollIntoView } from "utils/helper";
import LegalDetailsInformation from "./legalDetailsInformation";
import EditLegalDetailsInformation from "./editLegalDetailsInformation";
import UseLegalDetailsInformation from "./useLegalDetailsInformation";

function Index({ isShowEditIcon }) {
  const [isEditMode, setIsEditMode] = useState(false);
  const { isLegalDetailsLoading, onEditLegalDetails } =
    UseLegalDetailsInformation();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("legalDetailsScrollId");
  };

  const handleSave = async (values) => {
    await onEditLegalDetails(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditLegalDetailsInformation
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isLegalDetailsLoading}
      />
    );
  }

  return (
    <LegalDetailsInformation
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

export default Index;
Index.propTypes = {
  isShowEditIcon: PropTypes.bool,
};
